
<!--start section header-->
 
<header class="head">
    <div class="cover">
        <div class="container d-flex justify-content-center align-items-center pt-5">
         <div>
             <h2 class="pt-5">
                Departments
             </h2>
             <nav aria-label="breadcrumb">
                 <ol class="breadcrumb d-flex justify-content-center">
                   <li (click) = change() class="breadcrumb-item">
                       <a>Home</a>
                     </li>
                   <li class="breadcrumb-item active" aria-current="page">Departments</li>
                 </ol>
             </nav>
         </div>
 
        </div>
    </div>
 
 </header>
 
 <!--end section header-->

 <!--start section Departments-->

<section class="py-5 container departments">
    <div class="row pt-5">


        <div class="col-lg-4 col-md-6 mb-4">
            <div class="card">
                <img src="assets/images/23.jpg" class="card-img-top" alt="drugs">
                <div class="card-body">
                  <h5 class="card-title pl-3">Farnesoid X Receptor</h5>
                  <p class="card-text pl-3">Doner meatloaf pork loin tenderloin <br>
                     alcatra ground round shankle cupim <br>
                      spare ribs filet mignon venison.
                  </p>
                  <hr>
                  <div class="pl-3 pt-3 card-footers">
                      <p>
                        <i class="fas fa-map-marker-alt pr-3"></i>
                        3699 Wescam Court, Quincy
                      </p>
                      <p>
                        <i class="fas fa-phone-alt pr-3"></i>
                        0 (800) 123 4561
                      </p>
                      <p>
                        <i class="fas fa-envelope pr-3"></i>
                        farnesoid@example.com
                      </p>
                  </div>
                </div>
              </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-4">
            <div class="card">
                <img src="assets/images/h.jpg" class="card-img-top" alt="drugs">
                <div class="card-body ">
                  <h5 class="card-title">Therapeutic Focus</h5>
                  <p class="card-text">Fatback jerky pig sirloin. Beef landja pork <br>
                    beef ribs kielbasa shoulder tongue pig <br>
                     venison pork chop.
                  </p>
                  <hr>
                  <div class="pl-3 pt-3 card-footers">
                    <p>
                      <i class="fas fa-map-marker-alt pr-3"></i>
                      3699 Wescam Court, Quincy
                    </p>
                    <p>
                      <i class="fas fa-phone-alt pr-3"></i>
                      0 (800) 123 4561
                    </p>
                    <p>
                      <i class="fas fa-envelope pr-3"></i>
                      farnesoid@example.com
                    </p>
                </div>
                </div>
              </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-4">
            <div class="card">
                <img src="assets/images/24.jpg" class="card-img-top" alt="drugs">
                <div class="card-body ">
                  <h5 class="card-title">Investigator Initiated</h5>
                  <p class="card-text">Fatback jerky pig sirloin. Beef landja pork <br>
                    beef ribs kielbasa shoulder tongue pig <br>
                     venison pork chop.
                  </p>
                  <hr>
                  <div class="pl-3 pt-3 card-footers">
                    <p>
                      <i class="fas fa-map-marker-alt pr-3"></i>
                      3699 Wescam Court, Quincy
                    </p>
                    <p>
                      <i class="fas fa-phone-alt pr-3"></i>
                      0 (800) 123 4561
                    </p>
                    <p>
                      <i class="fas fa-envelope pr-3"></i>
                      farnesoid@example.com
                    </p>
                </div>
                </div>
              </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-4">
            <div class="card">
                <img src="assets/images/25.jpg" class="card-img-top" alt="drugs">
                <div class="card-body ">
                  <h5 class="card-title">Pipeline</h5>
                  <p class="card-text">Fatback jerky pig sirloin. Beef landja pork <br>
                    beef ribs kielbasa shoulder tongue pig <br>
                     venison pork chop.
                  </p>
                  <hr>
                  <div class="pl-3 pt-3 card-footers">
                    <p>
                      <i class="fas fa-map-marker-alt pr-3"></i>
                      3699 Wescam Court, Quincy
                    </p>
                    <p>
                      <i class="fas fa-phone-alt pr-3"></i>
                      0 (800) 123 4561
                    </p>
                    <p>
                      <i class="fas fa-envelope pr-3"></i>
                      farnesoid@example.com
                    </p>
                </div>
                </div>
              </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-4">
            <div class="card">
                <img src="assets/images/20.jpg" class="card-img-top" alt="drugs">
                <div class="card-body ">
                  <h5 class="card-title">Discovery Compounds</h5>
                  <p class="card-text">Fatback jerky pig sirloin. Beef landja pork <br>
                    beef ribs kielbasa shoulder tongue pig <br>
                     venison pork chop.
                 </p>
                 <hr>
                 <div class="pl-3 pt-3 card-footers">
                    <p>
                      <i class="fas fa-map-marker-alt pr-3"></i>
                      3699 Wescam Court, Quincy
                    </p>
                    <p>
                      <i class="fas fa-phone-alt pr-3"></i>
                      0 (800) 123 4561
                    </p>
                    <p>
                      <i class="fas fa-envelope pr-3"></i>
                      farnesoid@example.com
                    </p>
                </div>
                </div>
              </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-4">
            <div class="card">
                <img src="assets/images/26.jpg" class="card-img-top" alt="drugs">
                <div class="card-body ">
                  <h5 class="card-title">Presentations</h5>
                  <p class="card-text">Fatback jerky pig sirloin. Beef landja pork <br>
                     beef ribs kielbasa shoulder tongue pig <br>
                      venison pork chop.
                  </p>
                  <hr>
                  <div class="pl-3 pt-3 card-footers">
                    <p>
                      <i class="fas fa-map-marker-alt pr-3"></i>
                      3699 Wescam Court, Quincy
                    </p>
                    <p>
                      <i class="fas fa-phone-alt pr-3"></i>
                      0 (800) 123 4561
                    </p>
                    <p>
                      <i class="fas fa-envelope pr-3"></i>
                      farnesoid@example.com
                    </p>
                </div>
                </div>
              </div>
        </div>

    </div>
</section>

<!--end section Departments-->